import { VuexModule, Module, Mutation } from 'vuex-module-decorators';
import Store from '@/store/index';

@Module({
  dynamic: true,
  store: Store,
  name: 'patient',
  namespaced: true,
})
export default class Patient extends VuexModule {
  cachedUsers: { [key: string]: any } = {};

  @Mutation
  flushCachedById(id: string) {
    const changed = { ...this.cachedUsers }
    delete changed[id];
    this.cachedUsers = changed;
  }

  @Mutation
  flushAll() {
    this.cachedUsers = {};
  }

  @Mutation
  cacheOne(item: any) {
    this.cachedUsers = {
      ...this.cachedUsers,
      [item.$id]: item,
    };
  }

  get items() {
    return this.cachedUsers;
  }
}
